import React, { Component, createContext } from 'react'

const Mycontext = createContext()
export const { Provider, Consumer } = Mycontext

export default class ContextProvider extends Component {
    state = {
        theme: 'haha',
        themeStatus: false
    }

    toggleTheme= (e) => {
        this.setState({
            ...this.state,
            themeStatus: !this.state.themeStatus
        })
    }

    onChangeTheme = (e) => {

    }

    render() {
        const {state, toggleTheme, onChangeTheme} = this
        return (
            <Provider value={{ state: state , toggleTheme:toggleTheme, onChangeTheme:onChangeTheme}}>
                {this.props.children}
            </Provider>
        )
    }
}
